// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__-j-1H","total":"Cart_total__+QtiK","actions":"Cart_actions__7LgXl","button--alt":"Cart_button--alt__SHTsa","button":"Cart_button__MpzqH"};